export default function RefundPolicy() {
  return (
    <div data-testid="refund-policy-page">
      <section className="container-px pt-16 md:pt-24 pb-16">
        <div className="max-w-3xl">
          <div className="overline mb-6">Legal</div>
          <h1 className="font-heading text-5xl md:text-6xl font-light tracking-tight text-ink leading-[1.05]">
            Refund & Cancellation Policy
          </h1>
          <p className="mt-6 text-lg text-ink-soft leading-relaxed">
            Last Updated: July 11, 2026. This policy explains our terms for membership fee payments, application approvals, cancellations, and refunds.
          </p>
        </div>
      </section>

      <section className="container-px pb-24">
        <div className="max-w-3xl card-premium space-y-8">
          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">1. Membership Fees</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              Oswal Sabha Professional Forum charges a membership application fee when you apply to become a member of our forum. The fee is INR 2,100 for Indian residents and INR 1,100 for NRI members. These fees help support the community, run the professional directory, and support welfare activities.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">2. Refund Terms for Rejected Applications</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              All membership applications go through a moderation and approval process by the Sabha committee.
              <br />
              <strong className="text-brand font-semibold">Important:</strong> If your membership application is rejected by the moderation committee for any reason, <span className="underline">a full refund (100% of the application fee) will be initiated automatically</span>. The refund will be credited back to your original payment method within 5-7 business days.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">3. No Refund for Approved Memberships</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              Once an application is moderated and officially approved by the committee, the membership becomes active, and the membership fee is non-refundable and non-transferable under any circumstances.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">4. Cancellations</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              Members can request to deactivate their profile and remove their listings from the professional directory at any time by writing to our support email. However, deactivating your profile does not entitle you to any partial or full refund of the membership fee.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">5. Contact and Disputes</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              If you have any questions, encounter billing errors, or would like to check the status of a pending refund, please contact us at <a href="mailto:oswalsabhaprofessionalforum@gmail.com" className="text-orange-600 hover:underline">oswalsabhaprofessionalforum@gmail.com</a>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
